import { flatten } from 'lodash-es';
import { schemaPartItemTypeValues } from '../constants/types';
import { validation } from '../constants';

const { validationType, validationProblem, validationReason } = validation.surveyPart;

const collectQuestions = (surveyPartItems) => flatten(surveyPartItems
  .filter((item) => [
    schemaPartItemTypeValues.QUESTION,
    schemaPartItemTypeValues.QUESTION_GROUP
  ].includes(item.type))
  .map((item) => {
    if (item.type === schemaPartItemTypeValues.QUESTION) {
      return item.question;
    }
    return item.questionGroup.questions;
  }));

const validCode = new RegExp(/^[a-zA-ZåÅäÄöÖ0-9_-]+$/);
const validateCode = (code, type) => {
  if (code && validCode.test(code)) {
    return null;
  }

  return {
    type,
    problem: validationProblem.CODE,
    reason: validationReason.INVALID,
    value: code
  };
};

const findDuplicateCodes = (codes) => codes.reduce((acc, code, idx) => {
  if (codes.indexOf(code) !== idx && !acc.includes(code)) {
    acc.push(code);
  }
  return acc;
}, []);

const validateCodes = (items, type) =>
  items.map((item) => validateCode(item.code, type)).filter((item) => Boolean(item));

const checkForDuplicateCodes = (items, type) =>
  findDuplicateCodes(items.map((item) => item.code)).map((duplicate) => ({
    type,
    problem: validationProblem.CODE,
    reason: validationReason.DUPLICATE,
    value: duplicate
  }));

const validate = (surveyPartOptions) => {
  const questions = collectQuestions(surveyPartOptions.surveySchemaPartItems);

  return [
    ...validateCodes(questions, validationType.QUESTION),
    ...checkForDuplicateCodes(questions, validationType.QUESTION)
  ];
};

export default (data) => {
  const invalidFields = validate(data.surveySchemaPart);
  return {
    invalidFields,
    isValid: invalidFields.length === 0
  };
};
